import React from 'react';
import { connect } from 'react-redux';
import TopUpBalance, { ThreeDSPaymentResult } from '@beep/topup';
import PropTypes from 'prop-types';
import { closeInfoCard } from "../../store/infoCards/actions";
import { getIsPaymentModalOpen, getPaymentMethods } from "../../store/selectors";
import { getIsAuthFlag } from "../../store/shared/selectors";
var _Payment = function _Payment(_ref) {
  var isAuth = _ref.isAuth,
    isOpen = _ref.isOpen,
    methods = _ref.methods,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(TopUpBalance, {
    isAuth: isAuth,
    isOpen: isOpen,
    paymentMethods: methods,
    setIsOpen: onClose,
    userInfo: {
      type: 1
    },
    "data-t-id": "components-Payment"
  }), /*#__PURE__*/React.createElement(ThreeDSPaymentResult, {
    onContinue: onClose,
    paymentMethods: methods
  }));
};
_Payment.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool,
  methods: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuth: getIsAuthFlag(state),
    isOpen: getIsPaymentModalOpen(state),
    methods: getPaymentMethods(state)
  };
};
var mapDispatchToProps = {
  onClose: closeInfoCard
};
export var Payment = connect(mapStateToProps, mapDispatchToProps)(_Payment);